export default __webpack_public_path__ + "static/media/eliqx-learn-more-hp.ff2f0ed7.mp4";